// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3asOU","dragIcon":"Choice_dragIcon__1c1r7","left":"Choice_left__1xDOE","input":"Choice_input__1y5zG"};